import React from "react";
import { AiFillFacebook } from "react-icons/ai";
import { MdEmail } from "react-icons/md";
import { FaSquareGithub } from "react-icons/fa6";
import "../Style/footer.css";

function MyFooter() {
  return (
    <div className="myfooter">
      <div className="myfoot">
        {" "}
        <div className="mfleft">
          &copy; 2024{" "}
          <a href="https://www.olawale.net" className="mfpurple">
            Olawale
          </a>{" "}
          All right Reserved.
        </div>
        <div className="mfright">
          <a href="mailto: shuaibolawale77@gmail.com">
            <MdEmail className="mficon" />
          </a>
          <a href="https://github.com/Snotat">
            <FaSquareGithub className="mficon" />
          </a>
          <a href="https://www.facebook.com/snotat">
            <AiFillFacebook className="mficon" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default MyFooter;
